import React from "react";
import { Page, NavItem, TabPane } from "components/common";
import { Nav, TabContent } from "reactstrap";
import { QuotesTable } from "./QuotesTable";
import { Trans } from "react-i18next";
import { XeroClient } from "services";
import { Link, Switch, Redirect } from "react-router-dom";
import {
  ACCEPTED,
  ALL,
  DECLINED,
  DRAFT,
  INVOICED,
  SENT,
} from "./constants/statuses";
import { renderCountSpan } from "services/util";

const getTable = (status) => (props) =>
  <QuotesTable b={console.log(status, "111")} status={status} {...props} />;

const All = getTable(ALL);
const Draft = getTable(DRAFT);
const Sent = getTable(SENT);
const Declined = getTable(DECLINED);
const Accepted = getTable(ACCEPTED);
const Invoiced = getTable(INVOICED);

export const QuotesList = ({ match }) => {

  const xero = XeroClient();

  const [pOrders, setPOrders] = React.useState();

  React.useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await xero.get("quotes", {       
          params: {
            extra_params: {
              //where: 'Status="DRAFT"||Status="AUTHORISED"||Status="SUBMITTED"',
              limit: 100,
            }
          }
        })
        const poData = response.data;
        setPOrders(poData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  function processAccountData(data) {
    const lengthAll = data ? data.length : 0;
    let lengthDraft = 0;
    let lengthDeclined = 0;
    let lengthAccepted = 0;
    let lengthSent = 0;
    let lengthInvoiced = 0;
  
    if (lengthAll > 0) {
      for (let i = 0; i < lengthAll; i++) {
        const status = data[i].Status;
  
        if (status === "DRAFT") {
          lengthDraft++;
        } else if (status === "DECLINED") {
          lengthDeclined++;
        } else if (status === "SENT") {
          lengthSent++;
        } else if (status === "ACCEPTED") {
          lengthAccepted++;
        } else if (status === "INVOICED") {
          lengthInvoiced++;
        }
      }
    } else {
      console.log("No data available");
    }
  
    return {
      lengthAll,
      lengthDraft,
      lengthDeclined,
      lengthAccepted,
      lengthSent,
      lengthInvoiced,
    };
  }
  
  const {
    lengthAll,
    lengthDraft,
    lengthDeclined,
    lengthAccepted,
    lengthSent,
    lengthInvoiced,
  } = processAccountData(pOrders);
  

  return (
    <Page  className="inv-tabs nw-list" title={"Quotes"}>
      <div>
        <div className="pb-2">
          <Link to={`${match.url}/edit/new`} className="btn btn-primary ml-0">
            <span className="fa fa-plus" />
            <span className="mx-1" />
            <Trans>New Quote </Trans>
          </Link>
        </div>
        <Nav tabs className="nw-tabs2 inv-tabs my-3">
          <NavItem to={`all`} translate={false}><Trans>All</Trans> {renderCountSpan(lengthAll)}</NavItem>
          <NavItem to={`draft`} translate={false}><Trans>Draft</Trans> {renderCountSpan(lengthDraft)}</NavItem>
          <NavItem to={`sent`} translate={false}><Trans>Awaiting Approval</Trans> {renderCountSpan(lengthSent)}</NavItem>
          <NavItem to={`approved`} translate={false}><Trans>Awaiting Payment</Trans> {renderCountSpan(lengthAccepted)}</NavItem>
          <NavItem to={`declined`} translate={false}><Trans>Paid</Trans> {renderCountSpan(lengthDeclined)}</NavItem>
          <NavItem to={`invoiced`} translate={false}><Trans>Paid</Trans> {renderCountSpan(lengthInvoiced)}</NavItem>
        </Nav>

        <TabContent>
          <Switch>
            <TabPane path={`${match.url}/all`} component={All} />
            <TabPane path={`${match.url}/draft`} component={Draft} />
            <TabPane path={`${match.url}/sent`} component={Sent} />
            <TabPane path={`${match.url}/approved`} component={Accepted} />
            <TabPane path={`${match.url}/declined`} component={Declined} />
            <TabPane path={`${match.url}/invoiced`} component={Invoiced} />
            <Redirect to={`${match.url}/all`} />
          </Switch>
        </TabContent>
      </div>
    </Page>
  );
};
